var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBancoTipoCuenta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 508.008 508.008",
    style: {
      enableBackground: "new 0 0 508.008 508.008"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41596B"
    },
    d: "M499.128,242.808l-60.4-226.7c-3.1-11.6-14.9-18.4-26.5-15.4l-385.7,102.7 c-18,4.8-28.7,23.2-23.9,41.2l57.3,215.1c4.8,18,23.2,28.7,41.2,23.9l374.1-99.6C493.228,279.208,503.928,260.808,499.128,242.808z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.944,
    y: 127.825,
    transform: "matrix(0.9663 -0.2573 0.2573 0.9663 -31.4623 66.7156)",
    style: {
      fill: "#334A5E"
    },
    width: 454.486,
    height: 51.498
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#89D6F7"
    },
    d: "M485.428,214.608h-417.6c-11.7,0-21.2,9.5-21.2,21.2v251c0,11.7,9.5,21.2,21.2,21.2h417.5 c11.7,0,21.2-9.5,21.2-21.2v-251C506.528,224.108,497.128,214.608,485.428,214.608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M470.828,316.808h-107.3c-1.1,0-2-0.9-2-2v-64.5c0-1.1,0.9-2,2-2h107.3c1.1,0,2,0.9,2,2v64.5 C472.828,315.908,472.028,316.808,470.828,316.808z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.428,
    y: 422.808,
    style: {
      fill: "#FFD05C"
    },
    width: 69.8,
    height: 26.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.928,
    y: 422.808,
    style: {
      fill: "#F2705B"
    },
    width: 69.8,
    height: 26.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.528,
    y: 422.808,
    style: {
      fill: "#FFD05C"
    },
    width: 69.8,
    height: 26.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.128,
    y: 422.808,
    style: {
      fill: "#F2705B"
    },
    width: 69.8,
    height: 26.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.428,
    y: 356.608,
    style: {
      fill: "#55BFE9"
    },
    width: 222.5,
    height: 26.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.428,
    y: 290.508,
    style: {
      fill: "#F2F2F2"
    },
    width: 139.6,
    height: 26.2
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBancoTipoCuenta);
export default __webpack_public_path__ + "static/media/banco_tipo_cuenta.cf8ae38663f8d7d5e5509eba51feb91c.svg";
export { ForwardRef as ReactComponent };